import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Loading from '../../core/Loading';
import { usePermission } from '../../core/PermissionContext';
import { isAuthenticated } from '../../utils/auth';
import { isUserAdmin } from '../../utils/requestUtils';

const ProtectedRoute = ({ children, requireAuth = true, adminOnly = false }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { loadingPermissions } = usePermission();
    const [adminChecked, setAdminChecked] = useState(!adminOnly);

    useEffect(() => {
        if (requireAuth && !isAuthenticated()) {
            const currentPath = location.pathname + location.search;
            if (currentPath !== '/login' && !currentPath.startsWith('/login?')) {
                sessionStorage.setItem('redirectAfterLogin', currentPath);
            }
            navigate('/login');
            return;
        }
        if (adminOnly) {
            isUserAdmin().then(admin => {
                if (!admin) navigate('/unauthorizedaccess');
                else setAdminChecked(true);
            }).catch(() => navigate('/unauthorizedaccess'));
        }
    }, [navigate, location, requireAuth, adminOnly]);

    if (loadingPermissions || !adminChecked) {
        return <Loading />;
    }

    if (requireAuth && !isAuthenticated()) {
        return null;
    }

    return children;
};

export default ProtectedRoute;
